module.exports = __webpack_public_path__ + "static/media/image_placeholder.5a8fc0b4.jpg";